import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {BusinessDirectory} from '../models/business-directory';
import {API_URL} from '../constants';


@Injectable({
    providedIn: 'root'
})
export class BusinessDirectoryService {
    private baseUrl = `${API_URL}business-directory`;

    constructor(private http: HttpClient) {
    }

    // Create a new business entry
    createBusiness(business: BusinessDirectory): Observable<BusinessDirectory> {
        return this.http.post<BusinessDirectory>(this.baseUrl, business);
    }

    // Update an existing business entry
    updateBusiness(id: string, business: BusinessDirectory): Observable<BusinessDirectory> {
        return this.http.put<BusinessDirectory>(`${this.baseUrl}/${id}`, business);
    }

    // Get business by ID
    getBusinessById(id: string): Observable<BusinessDirectory> {
        return this.http.get<BusinessDirectory>(`${this.baseUrl}/${id}`);
    }

    // Delete business entry
    deleteBusiness(id: string): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${id}`);
    }

    // Get all business entries
    getBusinesses(): Observable<BusinessDirectory[]> {
        return this.http.get<BusinessDirectory[]>(`${this.baseUrl}`);
    }

    // Get businesses by user ID
    getBusinessesByUser(userId: string): Observable<BusinessDirectory[]> {
        return this.http.get<BusinessDirectory[]>(`${this.baseUrl}/user/${userId}`);
    }


}
